export var VERSION = '1.2.3';